module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1024-a12cb5fed13017168abc02b59b552b65.png";